export default __webpack_public_path__ + "42a2eea0578888caf0924209a65ab4f5.svg";